var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31319 12.5352H5.98519V10.8712L6.88119 9.80716L8.44919 12.5352H9.19319L7.29719 9.28716L8.94519 7.28716H8.18519L6.00119 9.91916H5.98519V7.28716H5.31319V12.5352ZM10.0669 12.5352H10.6829V9.64716C10.6829 9.18316 10.6349 8.55916 10.6029 8.09516H10.6349L11.0509 9.26316L12.0589 12.0072H12.4429L13.4509 9.26316L13.8669 8.09516H13.8989C13.8669 8.55916 13.8109 9.18316 13.8109 9.64716V12.5352H14.4429V7.28716H13.6589L12.6509 10.1032L12.2829 11.1752H12.2509L11.8749 10.1032L10.8589 7.28716H10.0669V12.5352Z",
    fill: "#617AF7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.4438,
    cy: 9.36274,
    r: 8.29302,
    stroke: "#617AF7",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKm);
export default __webpack_public_path__ + "static/media/km.ceb3ce755440e8deeef1dede021256a1.svg";
export { ForwardRef as ReactComponent };